import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { Link } from '@naf-simba/elements-links';
import styled from '@emotion/styled';
import { MembershipBenefitReference } from '@appTypes/membershipBenefitReferenceType';
import BenefitsList from '@pages/BenefitArticle/NewRelatedBenefits/BenefitList/BenefitList';

interface Props {
  title?: string;
  benefits?: MembershipBenefitReference[];
  total?: number;
}
export const MembershipBenefitsBlock = ({ title, benefits, total }: Props) =>
  (benefits && (
    <div>
      <HeadingWrapper>
        <Text variant={TextVariant.Header2}>{title || 'Medlemsfordeler'}</Text>
        <Link tapTarget to="/medlemskap/medlemsfordeler" text={`Se alle (${total?.toFixed(0)})`} />
      </HeadingWrapper>
      <BenefitsList benefitItems={benefits} />
    </div>
  )) ||
  null;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
